import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class ProfessionalDetails extends Component {

    constructor(props){
      super(props);
      this.state = {
        isLoading: false,
        successMsg: "",
        errorMsg: "",
        currentDesignationUI: this.getPropertyValue("currentDesignation"),
        currentHospitalUI: this.getPropertyValue("currentHospital"),
        currentWorkingCityUI: this.getPropertyValue("currentWorkingCity"),
        currentWorkingStateUI: this.getPropertyValue("currentWorkingState"),
        experienceUI: this.getPropertyValue("experience"),
        websiteUI: this.getPropertyValue("website"),
      }

    }

    getPropertyValue(propertyName){

       if(this.props.userProfile[propertyName] && this.props.userProfile[propertyName].length > 0){
         return this.props.userProfile[propertyName];
       }
       return "";
    }

    submitForm = async event => {
      event.preventDefault();
      this.setState({ isLoading: true});
      var personalDetails = {};

      try{

        await this.props.updateUserProfile(this.state);
        this.setState({isLoading: false, successMsg: "Successfully updated your interests."});

      }catch(e){
        this.setState({isLoading: false, errorMsg: e.message});
      }
    }

    editProfile(userDetails){
      return API.put("retnetindia", "/user/profile", {
        body: userDetails
      })
    }

    validateForm(){
      return true;
    }

    handleChange = event => {
      event.preventDefault();

      if(event.target.value.length > 0){
        this.setState({
          [event.target.id]: event.target.value
        });
      }

      this.setState({
        [event.target.id+"UI"]: event.target.value,
        successMsg: "",
        errorMsg: ""
      });


    }

    getSuccessNotification(successMsg){
      return this.state.successMsg && this.state.successMsg.length > 0
                              ? <div className="alert alert-success" role="alert">
                                  {this.state.successMsg}
                                </div>
                              : "";
    }

    getErrorElement(){
       return this.state.errorMsg && this.state.errorMsg.length > 0
                               ? <div className="alert alert-danger" role="alert">
                                   {this.state.errorMsg}
                                 </div>
                               : "";
    }

    render(){
      return(
        <div className="container">
              <br />
              <div className="row cols-xs-space cols-sm-space cols-md-space">
                    <div className="col-lg-12">
                      <div className="row">
                           <div className="col-lg-2"></div>
                           <div className="col-lg-8 profile-udpate-widget">
                             <div class="card">
                                 <div class="card-title b-xs-bottom">
                                     <h3 class="heading heading-sm text-uppercase">Professional Details</h3>

                                 </div>
                                 <div class="card-body">
                                     <form id="professional-details-form" onSubmit={this.submitForm}>
                                         <div className="row">
                                             <div className="col-md-6">
                                                 <div className="form-group">
                                                     <label for="currentDesignation">Designation</label>
                                                     <input type="text" id="currentDesignation"
                                                          className="form-control"
                                                          value={this.state.currentDesignationUI}
                                                          placeholder=""
                                                          onChange={this.handleChange} />
                                                 </div>
                                             </div>
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="currentHospital">Hospital you work</label>
                                                       <input type="text" id="currentHospital"
                                                            className="form-control"
                                                            value={this.state.currentHospitalUI}
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>

                                             </div>
                                         </div>

                                         <div className="row">
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="currentWorkingCity">City you work in </label>
                                                       <input type="text" id="currentWorkingCity"
                                                            className="form-control"
                                                            value={this.state.currentWorkingCityUI}
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>
                                             </div>
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="currentWorkingState">State you work in </label>
                                                       <input type="text" id="currentWorkingState"
                                                            className="form-control"
                                                            value={this.state.currentWorkingStateUI}
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>
                                             </div>
                                         </div>


                                         <div className="row">
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="experience">Total Experience</label>
                                                       <input type="text" id="experience"
                                                            className="form-control"
                                                            value={this.state.experienceUI}
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>
                                             </div>
                                             <div className="col-md-6">
                                                   <div className="form-group">
                                                       <label for="website">Website Url (if any)</label>
                                                       <input type="text" id="website"
                                                            className="form-control"
                                                            valu={this.state.websiteUI}
                                                            placeholder=""
                                                            onChange={this.handleChange} />
                                                   </div>

                                             </div>
                                         </div>

                                         <br />
                                         <div className="form-group align-center">

                                             <LoaderButton block bsStyle="primary" bsSize="large"
                                                   disable={!this.validateForm()} type="submit"
                                                   isLoading={this.state.isLoading} text=" Update "
                                                   loadingText="Updating Details..."
                                                   className="btn btn-primary"/>
                                         </div>
                                     </form>
                                     {this.getErrorElement()}
                                     {this.getSuccessNotification()}
                                 </div>
                             </div>
                           </div>
                            <div className="col-lg-2"></div>
                      </div>
                    </div>
              </div>
       </div>



      );
    }

}



// WEBPACK FOOTER //
// ./src/containers/ProfessionalDetails.js